/**
 * Used to tell the WriteValues method on componets to override form validity if necessary
 */
export enum WriteValueOverride {
    Default,
    Override,
    SaveState
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/purchase/models/write-value-override.enum.ts